import React, { useState } from 'react';
import './Projects.css';
import icon1 from './assets/icon1.png';
import icon2 from './assets/icon2.png';

const projects = [
    {
      name: "Ricette di Famiglia",
      icon: <img src={icon2} alt="Project 1" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />,
      tech: ["React", "CSS", "Latex"],
      status: "wip", // "active", "wip", or "completed"
      description: "Derived from my family cookbook, I'm working on making an interactive website of our recipes. Ideally, I'd like to be able to look up recipes, meal prep, randomise recipes, and put together grocery lists to help plan the week with all my favourite meals.",
      link: "/ricette"
    },
    {
        name: "Heavy Rain",
        icon: <img src={icon1} alt="Project 2" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />,
        tech: ["P5Play", "JavaScript", "HTML"],
        status: "completed", // "active", "wip", or "completed"
        description: "This game was developped as a final project for Dennis Shasha's course 'Heuristic Problem Solving'. The idea was to create a game that would be simple to explain to a ten year old, but computationally difficult to solve optimally. My inspiration came from watchng water droplets fall down the wall in the shower.",
        link: "https://cs.nyu.edu/~shasha/drecco/games/2025/heavyrain/"
    },
    {
        name: "Briscola",
        icon: <img src={icon2} alt="Project 2" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />,
        tech: ["React", "CSS", "HTML"],
        status: "active", // "active", "wip", or "completed"
        description: "I'm building a simple web app to play Briscola, an Italian card game, with my family when I'm away.",
        link: "/briscola"
    },
    {
        name: "Sharing Schemes",
        icon: <img src={icon1} alt="Project 2" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />,
        tech: ["Python"],
        status: "completed", // "active", "wip", or "completed"
        description: "This project was developped with Bradley Cushing as part of Benedikt Bünz's course 'Cryptography of Blockchains'. The idea was to implement various secret sharing schemes, then to compare and benchmark them.",
        link: "/SecretSharing.pdf",
        github: "https://github.com/SamdeAlfaro/SharingSchemes"
    },
    {
        name: "Maximal Matchings",
        icon: <img src={icon1} alt="Project 2" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />,
        tech: ["Python"],
        status: "completed", // "active", "wip", or "completed"
        description: "This was a project in collaboration with Rishi Kaushik and Gordon Lu under Prof. Aaron Bernstein in the course 'Recent Developments in Algorithm Design'. We analysed the expected perfomance of the Random-Order Greedy Maximum Matching algorithm with respect to some algorithm OPT that produces an optimal matching. One result was showing that for graphs in which each vertex has at most degree 2, ROG-MM in expectation produces a matching of size 0.864OPT. Other results can be found in the paper.",
        link: "/MaximalMatching.pdf",
        github: "https://github.com/SamdeAlfaro/MaximalMatchings"
    },
    {
        name: "Dismantle the Computer",
        icon: <img src={icon1} alt="Project 2" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />,
        tech: ["Unity", "HTML", "CSS", "Javascript"],
        status: "completed", // "active", "wip", or "completed"
        description: "This was my undergraduate capstone project under Prof. Cyd Cipolla. It examined computer science education, and proposes an art-history based pedagogy to teach computer science fundamentals to a broader audience through interactive experiences. The project culminated in an interactive game where players dismantle a virtual computer to learn about its components, documented as if they were artworks or artefacts. The website can be found under the github link, and the paper can be found under the project link.",
        link: "/DismantleComputer.pdf",
        github: "https://samdealfaro.github.io/DismantletheComputer/"
    },
  ];

const ProjectsGrid = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <div className="projects-grid-container">
      <div className="projects-screen">
        <div className="screen-header">✿ PROJECTS ✿</div>
        <div className="projects-body">
          {projects && projects.length > 0 ? (
            <div className="projects-grid">
              {projects.map((project, index) => (
                <div 
                  key={index} 
                  className={`project-card ${selectedProject === index ? 'selected' : ''}`}
                  onClick={() => setSelectedProject(selectedProject === index ? null : index)}
                >
                  {/* LED indicator */}
                  <div className={`project-led ${project.status || 'active'}`}></div>
                  
                  {/* Project icon/emoji */}
                  {project.icon && (
                    <div className="project-icon">{project.icon}</div>
                  )}
                  
                  {/* Project name */}
                  <div className="project-name">{project.name}</div>
                  
                  {/* Tech tags */}
                  {project.tech && project.tech.length > 0 && (
                    <div className="project-tech-tags">
                      {project.tech.slice(0, 2).map((tech, i) => (
                        <span key={i} className="tech-tag">{tech}</span>
                      ))}
                      {project.tech.length > 2 && (
                        <span className="tech-tag more">+{project.tech.length - 2}</span>
                      )}
                    </div>
                  )}
                  
                  {/* Expandable description */}
                  {selectedProject === index && (
                    <div className="project-details">
                      {project.description && (
                        <div className="project-description">{project.description}</div>
                      )}
                      {project.link && (
                        <a 
                          href={project.link} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="project-link"
                          onClick={(e) => e.stopPropagation()}
                        >
                          → VIEW PROJECT
                        </a>
                      )}
                      {project.github && (
                        <a 
                          href={project.github} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="project-link github"
                          onClick={(e) => e.stopPropagation()}
                        >
                          → GITHUB
                        </a>
                      )}
                    </div>
                  )}
                  
                  {/* Click indicator */}
                  <div className="click-hint">
                    {selectedProject === index ? '▲' : '▼'}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-projects">
              <div className="pixel-text">No projects yet!</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectsGrid;